import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router';
import { api } from '@/lib/api';
import type { AppDetail } from '@/lib/types';
import { currentAppRoute } from './nav';

/** Same query key and fetcher as AppLayout, so the sidebar and breadcrumbs share its cache entry. */
export function useCurrentApp() {
  const { pathname } = useLocation();
  const route = currentAppRoute(pathname);
  const q = useQuery({
    queryKey: ['app', route?.appId],
    enabled: !!route,
    queryFn: () => api<AppDetail>(`/admin/v1/apps/${route!.appId}`),
  });
  const app = route ? q.data : undefined;
  return { route, app };
}
